import * as account from './account';
import * as templates from './templates';

export default ({
  account,
  templates
});